import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { metadataForLocation } from './siteMetadata.js';
import { applyMetadata } from './headMetadata';

export default function RouteMetadata() {
  const location = useLocation();
  useEffect(() => {
    applyMetadata(document, metadataForLocation({
      pathname: location.pathname, search: location.search, origin: window.location.origin,
      production: process.env.REACT_APP_SEARCH_INDEXING === 'production',
    }));
  }, [location.pathname, location.search]);
  return null;
}
